export default __webpack_public_path__ + "assets/ico_feed_reactions-800a1ddc.svg";